import { render, staticRenderFns } from "./TitleBarSave.vue?vue&type=template&id=c8e89764"
import script from "./TitleBarSave.vue?vue&type=script&lang=js"
export * from "./TitleBarSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports